var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.642,15.245A10.952,10.952,0,0,0,16,9,7,7,0,0,0,2,9a10.952,10.952,0,0,0,2.358,6.245,24.79,24.79,0,0,0,4.318,4.5.487.487,0,0,0,.646,0A24.788,24.788,0,0,0,13.642,15.245ZM10.59,21.3C13.175,19.179,18,14.492,18,9A9,9,0,0,0,0,9c0,5.492,4.825,10.179,7.41,12.3A2.485,2.485,0,0,0,10.59,21.3Z",
    transform: "translate(1409.336 2685.066)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2ZM0,4A4,4,0,1,1,4,8,4,4,0,0,1,0,4Z",
    transform: "translate(1414.336 2690.066)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.07f9f349a4ab920e0260f9c2262a9bb1.svg";
export { ForwardRef as ReactComponent };